<!-- Independent Section Counter -->
<div class="d-flex align-items-center p-3 rooms-counter position-relative">
  <label class="me-2 fw-medium">Rooms:</label>
  <button
    type="button"
    class="counter-btn decrement"
    (click)="decrementSection()"
    [disabled]="sectionCount <= 1"
  >
    -
  </button>
  <span class="mx-3">{{ sectionCount }}</span>
  <button
    type="button"
    class="btn btn-outline-secondary counter-btn"
    (click)="incrementSection()"
  >
    +
  </button>
  <div class="modal-header position-absolute" (click)="closeModal()">
    <img src="assets/images/icons/cross-btn.svg" alt="close-btn" />
  </div>
</div>

<form [formGroup]="travellerForm" class="p-3 form-section">
  <!-- Traveller Sections -->
  <div class="traveller-selection-wrapper" formArrayName="travellers">
    <div
      *ngFor="let traveller of travellers.controls; let i = index"
      [formGroupName]="i"
      class="traveller-section"
    >
      <div class="traveller-item">
        <div class="heading-section d-flex flex-column">
          <label class="traveller-label">Adults</label>
          <span class="traveller-subtext">12 Years & Above</span>
        </div>
        <div class="counter-group">
          <button
            type="button"
            class="counter-btn decrement"
            (click)="decrementField(i, 'adults')"
            [disabled]="traveller.get('adults')?.value <= 1"
          >
            -
          </button>
          <span class="counter-value">{{
            traveller.get("adults")?.value
          }}</span>
          <button
            type="button"
            class="counter-btn increment"
            (click)="incrementField(i, 'adults')"
          >
            +
          </button>
        </div>
      </div>

      <div class="divider"></div>

      <div class="traveller-item">
        <div class="heading-section d-flex flex-column">
          <label class="traveller-label">Children</label>
          <span class="traveller-subtext">2-12 yrs</span>
        </div>
        <div class="counter-group">
          <button
            type="button"
            class="counter-btn decrement"
            (click)="decrementField(i, 'child')"
            [disabled]="traveller.get('child')?.value <= 0"
          >
            -
          </button>
          <span class="counter-value">{{ traveller.get("child")?.value }}</span>
          <button
            type="button"
            class="counter-btn increment"
            (click)="incrementField(i, 'child')"
          >
            +
          </button>
        </div>
      </div>

      <div class="divider"></div>

      <div class="traveller-item">
        <div class="heading-section d-flex flex-column">
          <label class="traveller-label">Infant</label>
          <span class="traveller-subtext">0-2 yrs</span>
        </div>
        <div class="counter-group">
          <button
            type="button"
            class="counter-btn decrement"
            (click)="decrementField(i, 'infant')"
            [disabled]="traveller.get('infant')?.value <= 0"
          >
            -
          </button>
          <span class="counter-value">{{
            traveller.get("infant")?.value
          }}</span>
          <button
            type="button"
            class="counter-btn increment"
            (click)="incrementField(i, 'infant')"
          >
            +
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="w-100 d-flex justify-content-center apply-button-container my-3">
  <app-button
    type="primary"
    class="slim fs-14"
    [title]="isTravellerApplyEnabled ? '' : 'Add a adult traveller to proceed'"
    (click)="applyTravellerChanges()"
    >Apply</app-button
  >
</div>
